import React from 'react';
import classNames from 'classnames/bind';
import styles from './VoucherDetail.module.scss';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Col, Row, Form } from 'antd';
import voucherAPI from '~/api/VoucherAPI';
import { getNumberWithCommas } from '~/utils';
import { IMAGES } from '~/assets/assetsPath';
import { Spin } from 'antd';
import { logEvent } from 'firebase/analytics';
import { analytics } from '~/service/firebase';

const cx = classNames.bind(styles);

const VoucherDetail = () => {
    const navigate = useNavigate();
    const { voucher_id } = useParams();

    //state
    const [voucher, setVoucher] = useState();
    const [isLoading, setIsLoading] = useState(false);

    const totalPriceProductOrder = localStorage.getItem('totalPriceProductOrder');

    const [scrollPosition, setScrollPosition] = useState(0);
    const handleScroll = () => {
        const position = window.pageYOffset;
        setScrollPosition(position);
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll, { passive: true });

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    useEffect(() => {}, [scrollPosition]);

    const handleGetVoucher = async () => {
        setIsLoading(true);
        try {
            const params = {
                fields: '["$all"]',
            };

            const res = await voucherAPI.getOneVoucherAPI(voucher_id, params);

            if (res.code === 200) {
                const item = res.results.object;
                setVoucher(item);
            }
        } catch (err) {
            console.log(err);
        }
        setIsLoading(false);
    };

    useEffect(() => {
        handleGetVoucher();
        // eslint-disable-next-line
    }, []);

    const handleAgreeVoucher = () => {
        localStorage.setItem('voucherSubmit', JSON.stringify(voucher));
        navigate(-1);
    };
    useEffect(() => {
        logEvent(analytics, 'VBeauty_Web_TrangThongTinKhuyenMai');
        // eslint-disable-next-line
    }, []);

    return (
        <Row className={cx('voucher_detail')}>
            {isLoading ? (
                <Row justify="center" align="middle" style={{ height: '500px' }}>
                    <Spin />
                </Row>
            ) : (
                <>
                    {' '}
                    {voucher?.id ? (
                        <Form className={cx('container')}>
                            <>
                                <Row className={cx('top-section')}>
                                    <Row className={cx('top-background')}></Row>
                                    <Row
                                        style={{ zIndex: scrollPosition > 45 ? 0 : 1000 }}
                                        className={cx('top-content')}
                                    >
                                        <Col span={8} className={cx('top-left')}>
                                            <img
                                                className={cx('top-img')}
                                                src={voucher?.thumbnail || IMAGES.ImagePlaceholder}
                                            />
                                        </Col>
                                        <Col span={16} className={cx('top-right')}>
                                            <div className={cx('top-title')}>{voucher?.name}</div>
                                            <span>
                                                Minimum Order{' '}
                                                {voucher?.minimum_price
                                                    ? getNumberWithCommas(voucher.minimum_price)
                                                    : ''}{' '}
                                                VND{' '}
                                            </span>
                                            <span className={cx('Notification')}>
                                                Number of uses: {voucher?.amount_used}
                                            </span>
                                        </Col>
                                    </Row>
                                </Row>
                                {voucher?.voucher_detail ? (
                                    <Row className={cx('body-section')}>
                                        <Col className={cx('body-row')}>
                                            <div dangerouslySetInnerHTML={{ __html: voucher?.voucher_detail }}></div>
                                        </Col>
                                    </Row>
                                ) : (
                                    ''
                                )}

                                <Form.Item style={{ marginTop: '40px' }}>
                                    <Row>
                                        <div
                                            className={
                                                totalPriceProductOrder >= voucher?.minimum_price
                                                    ? cx('btn_submit')
                                                    : cx('disabledbutton')
                                            }
                                            onClick={handleAgreeVoucher}
                                        >
                                            Agree
                                        </div>
                                    </Row>
                                </Form.Item>
                            </>
                        </Form>
                    ) : (
                        <Row justify="center" align="middle" className={cx('voucher_no_exist')}>
                            Promotion code does not exist
                        </Row>
                    )}
                </>
            )}
        </Row>
    );
};

export default VoucherDetail;
